import { createContext, useEffect, useState, useRef } from "react";
import {
    INPUT_IMAGE_TYPE,
    GENERATE_MODE,
    IMAGE_TYPE,
    CUSTOM_BKG_MODE,
    RESOLUTION_RATIO,
    RESOLUTION_ALIGN
} from "@utils/CONST"
import UtilsAlgo from '@utils/utilsAlgo';

export const GenerateContext = createContext()

export const GenerateContextProvider = (props) => {
    const defaultGenerateNum = props.imageType == IMAGE_TYPE.MODEL_VIDEO ? 1 : 4

    const isMounted = useRef(true)
    useEffect(() => {
        return () => isMounted.current = false
    }, [])

    const taskInfo = props.taskInfo || {}

    const [inputImageLoading, setInputImageLoading] = useState(false)
    const [topInputImageLoading, setTopInputImageLoading] = useState(false)
    const [bottomInputImageLoading, setBottomInputImageLoading] = useState(false)
    const [no1MultiAngleImageLoading, setNo1MultiAngleImageLoading] = useState(false)
    const [no2MultiAngleImageLoading, setNo2MultiAngleImageLoading] = useState(false)

    const [imageType] = useState(props.imageType)
    // 项目id
    const [projectId, setProjectId] = useState(taskInfo.projectId)
    // 输入图/单件服装
    const [inputImage, setInputImage] = useState(taskInfo.inputImage)
    // 输入图宽度
    const [inputImageWidth, setInputImageWidth] = useState(taskInfo.inputImageWidth)
    // 输入图高度
    const [inputImageHeight, setInputImageHeight] = useState(taskInfo.inputImageHeight)
    // 输入图分割id
    const [inputImageMaskId, setInputImageMaskId] = useState(taskInfo.inputImageMaskId)
    // 多语义分割
    const [inputImageMultiSemanticId, setInputImageMultiSemanticId] = useState(taskInfo.inputImageMultiSemanticId)
    // 输入图原始mask
    const [inputImageOriginalMask, setInputImageOriginalMask] = useState(taskInfo.inputImageOriginalMask)
    // 输入图编辑后的mask
    const [inputImageEditedMask, setInputImageEditedMask] = useState(taskInfo.inputImageEditedMask)
    // 输入图npy算法id
    const [inputImageNpyId, setInputImageNpyId] = useState(null)

    // 仅AI模特
    const [inputImageColorMaskId, setInputImageColorMaskId] = useState(taskInfo.inputImageColorMaskId)

    // 仅AI试衣
    // AI试衣服装类型
    const [inputImageClothType, setInputImageClothType] = useState(taskInfo.inputImageClothType)
    // 上装输入图
    const [topInputImage, setTopInputImage] = useState(taskInfo.topInputImage)
    // 上装输入图宽度
    const [topInputImageWidth, setTopInputImageWidth] = useState(taskInfo.topInputImageWidth)
    // 上装输入图高度
    const [topInputImageHeight, setTopInputImageHeight] = useState(taskInfo.topInputImageHeight)
    // 上装输入图分割id
    const [topInputImageMaskId, setTopInputImageMaskId] = useState(taskInfo.topInputImageMaskId)
    // 上装输入图原始mask
    const [topInputImageOriginalMask, setTopInputImageOriginalMask] = useState(taskInfo.topInputImageOriginalMask)
    // 上装输入图编辑后的mask
    const [topInputImageEditedMask, setTopInputImageEditedMask] = useState(taskInfo.topInputImageEditedMask)
    // 上装输入图npy算法id
    const [topInputImageNpyId, setTopInputImageNpyId] = useState(null)
    // 输入图/上下搭配输入图-下装
    const [bottomInputImage, setBottomInputImage] = useState(taskInfo.bottomInputImage)
    // 下装输入图宽度
    const [bottomInputImageWidth, setBottomInputImageWidth] = useState(taskInfo.bottomInputImageWidth)
    // 下装输入图高度
    const [bottomInputImageHeight, setBottomInputImageHeight] = useState(taskInfo.bottomInputImageHeight)
    // 下装输入图分割id
    const [bottomInputImageMaskId, setBottomInputImageMaskId] = useState(taskInfo.bottomInputImageMaskId)
    // 下装输入图原始mask
    const [bottomInputImageOriginalMask, setBottomInputImageOriginalMask] = useState(taskInfo.bottomInputImageOriginalMask)
    // 下装输入图编辑后的mask
    const [bottomInputImageEditedMask, setBottomInputImageEditedMask] = useState(taskInfo.bottomInputImageEditedMask)
    // 下装输入图npy算法id
    const [bottomInputImageNpyId, setBottomInputImageNpyId] = useState(null)

    // 仅鞋子上脚
    // 多视角图1
    const [no1MultiAngleImage, setNo1MultiAngleImage] = useState(taskInfo.no1MultiAngleImage)
    // 多视角图宽度
    const [no1MultiAngleImageWidth, setNo1MultiAngleImageWidth] = useState(taskInfo.no1MultiAngleImageWidth)
    // 多视角图高度
    const [no1MultiAngleImageHeight, setNo1MultiAngleImageHeight] = useState(taskInfo.no1MultiAngleImageHeight)
    // 多视角图分割id
    const [no1MultiAngleImageMaskId, setNo1MultiAngleImageMaskId] = useState(taskInfo.no1MultiAngleImageMaskId)
    // 多视角图原始mask
    const [no1MultiAngleImageOriginalMask, setNo1MultiAngleImageOriginalMask] = useState(taskInfo.no1MultiAngleImageOriginalMask)
    // 多视角图编辑后的mask
    const [no1MultiAngleImageEditedMask, setNo1MultiAngleImageEditedMask] = useState(taskInfo.no1MultiAngleImageEditedMask)
    // 多视角图npy算法id
    const [no1MultiAngleImageNpyId, setNo1MultiAngleImageNpyId] = useState(null)
    // 多视角图2
    const [no2MultiAngleImage, setNo2MultiAngleImage] = useState(taskInfo.no2MultiAngleImage)
    // 多视角图宽度
    const [no2MultiAngleImageWidth, setNo2MultiAngleImageWidth] = useState(taskInfo.no2MultiAngleImageWidth)
    // 多视角图高度
    const [no2MultiAngleImageHeight, setNo2MultiAngleImageHeight] = useState(taskInfo.no2MultiAngleImageHeight)
    // 多视角图分割id
    const [no2MultiAngleImageMaskId, setNo2MultiAngleImageMaskId] = useState(taskInfo.no2MultiAngleImageMaskId)
    // 多视角图原始mask
    const [no2MultiAngleImageOriginalMask, setNo2MultiAngleImageOriginalMask] = useState(taskInfo.no2MultiAngleImageOriginalMask)
    // 多视角图编辑后的mask
    const [no2MultiAngleImageEditedMask, setNo2MultiAngleImageEditedMask] = useState(taskInfo.no2MultiAngleImageEditedMask)
    // 多视角图npy算法id
    const [no2MultiAngleImageNpyId, setNo2MultiAngleImageNpyId] = useState(null)

    // 仅商品
    // 商品自定义场景配置
    const [refImgConfig, setRefImgConfig] = useState(taskInfo.refImgConfig)
    // 商品自定义场景强度 默认：相似风格(0.7);拍同款(0.6)
    const [refImgStrength, setRefImgStrength] = useState((taskInfo.refImgStrength || taskInfo.refImgStrength === 0) ? taskInfo.refImgStrength : 0.7)
    // 商品图输出比例
    const [outputRatio, setOutputRatio] = useState(taskInfo.outputRatio || RESOLUTION_RATIO.CUSTOM)
    // 商品图输出宽度
    const [outputWidth, setOutputWidth] = useState(taskInfo.outputWidth || 1024)
    // 商品图输出高度
    const [outputHeight, setOutputHeight] = useState(taskInfo.outputHeight || 1024)
    // 输入图的位置、缩放、尺寸、旋转等信息 (原dragScaleRef.current)
    const [inputImageTransform, setInputImageTransform] = useState(taskInfo.inputImageTransform)

    // 试衣模特选择
    const [tryonModelKeyList, setTryonModelKeyList] = useState(taskInfo.tryonModelKeyList || [])
    // 姿势裂变参考图
    const [poseTryonKeyList, setPoseTryonKeyList] = useState(taskInfo.poseTryonKeyList || [])
    // 眼镜试戴参考图
    const [glassesTryonKeyList, setGlassesTryonKeyList] = useState(taskInfo.glassesTryonKeyList || [])
    // 同版型参考图
    const [simTryonKeyList, setSimTryonKeyList] = useState(taskInfo.simTryonKeyList || [])
    // 模特选择
    const [modelKeyList, setModelKeyList] = useState(taskInfo.modelKeyList || [])
    // 模特场景选择
    const [sceneKeyList, setSceneKeyList] = useState(taskInfo.sceneKeyList || [])
    // 试鞋参考图选择
    const [shoesKeyList, setShoesKeyList] = useState(taskInfo.shoesKeyList || [])
    // 视频参考图选择
    const [videoKeyList, setVideoKeyList] = useState(taskInfo.videoKeyList || [])
    // 商品颜色选择
    const [colorKeyList, setColorKeyList] = useState(taskInfo.colorKeyList || [])

    // 生成张数
    const [generateNum, setGenerateNum] = useState(taskInfo.generateNum || defaultGenerateNum)
    // 生成模式 =std 普通 =hq 高品质
    const [generateMode, setGenerateMode] = useState(taskInfo.generateMode || GENERATE_MODE.STD)
    // 人像皮肤优化
    const [skinRefine, setSkinRefine] = useState(taskInfo.skinRefine || 0)
    // 人像光影融合
    const [relight, setRelight] = useState(taskInfo.relight || 0.0)
    // 自定义背景模式 =free 更加自由 =sim 非常相似
    const [customBkgMode, setCustomBkgMode] = useState(taskInfo.customBkgMode || CUSTOM_BKG_MODE.FREE)
    // 模特换背是否选择输出参考图分辨率
    const [resolutionAlign, setResolutionAlign] = useState(taskInfo.resolutionAlign || RESOLUTION_ALIGN.BKG)
    // 输入图类型：单件服装/上下搭配 | 单视角图/多视角图
    const [currentInputType, setCurrentInputType] = useState(taskInfo.currentInputType || INPUT_IMAGE_TYPE.SINGLE)
    // 资源筛选项
    const [resourceFilter, setResourceFilter] = useState({
        sex: [], // 性别
        age: [], // 年龄
        skin: [], // 肤色
        shoesType: [], // 鞋子品类 
        pose: [], // 姿势
        clothesCate: [], // 服饰品类
        view: [], //姿势裂变视角
        clothStyles: [], // 图片构图
        clothPatterns: [], // 服装分类
        clothTypes: [], // 服装类目
        commodityType: null, // 商品品类 only commodity
        recommendCommodityType: null, // 推荐的商品品类 only commodity
        sceneType: null, // 场景品类 only commodity OR model
        sceneTags: [], // 模特背景
        compositionTags: [], // 模特构图
        toneTags: [], // 气质类型
        ...taskInfo.resourceFilter,
    })

    // 生成按钮是否禁用
    const generateDisabled = () => {
        if (imageType == IMAGE_TYPE.CLOTHES) {
            const inputValid = (currentInputType == INPUT_IMAGE_TYPE.SINGLE && !!inputImage) || (currentInputType == INPUT_IMAGE_TYPE.MULTI && !!topInputImage && !!bottomInputImage)
            const resourceValid = tryonModelKeyList.length > 0
            return !(inputValid && resourceValid)
        } else if (imageType == IMAGE_TYPE.POSE_TRYON) {
            const inputValid = !!inputImage
            const resourceValid = poseTryonKeyList.length > 0
            return !(inputValid && resourceValid)
        } else if (imageType == IMAGE_TYPE.GLASSES_TRYON) {
            const inputValid = !!inputImage
            const resourceValid = glassesTryonKeyList.length > 0
            return !(inputValid && resourceValid)
        } else if (imageType == IMAGE_TYPE.SIM_TRYON) {
            const inputValid = !!inputImage
            const resourceValid = simTryonKeyList.length > 0
            return !(inputValid && resourceValid)
        } else if (imageType == IMAGE_TYPE.MODEL) {
            const inputValid = !!inputImage
            const resourceValid = modelKeyList.length > 0 || sceneKeyList.length > 0
            return !(inputValid && resourceValid)
        } else if (imageType == IMAGE_TYPE.SHOES) {
            const inputValid = (currentInputType == INPUT_IMAGE_TYPE.SINGLE && !!inputImage) || (currentInputType == INPUT_IMAGE_TYPE.MULTI && !!no1MultiAngleImage && !!no2MultiAngleImage)
            const resourceValid = shoesKeyList.length > 0
            return !(inputValid && resourceValid)
        } else if (imageType == IMAGE_TYPE.MODEL_VIDEO) {
            const inputValid = !!inputImage
            const resourceValid = videoKeyList.length > 0
            return !(inputValid && resourceValid)
        } else if (imageType == IMAGE_TYPE.COMMODITY) {
            const inputValid = !!inputImage
            const resourceValid = sceneKeyList.length > 0
            return !(inputValid && resourceValid)
        } else if (imageType == IMAGE_TYPE.COMMODITYRECOLOR) {
            const inputValid = !!inputImage
            const resourceValid = colorKeyList.length > 0
            return !(inputValid && resourceValid)
        }

        return true
    }
    const getMultiSemanticId = UtilsAlgo.getMultiSemanticId
    const getMultiSemanticOutput = id => UtilsAlgo.getMultiSemanticOutput(id, () => !isMounted.current)
    const getClothMaskId = UtilsAlgo.getClothMaskId
    const getShoesMaskId = UtilsAlgo.getShoesMaskId
    const getGlassesMaskId = UtilsAlgo.getGlassesMaskId
    const getSimMaskId = UtilsAlgo.getSimMaskId
    const getSemanticSimTryonMaskId = UtilsAlgo.getSemanticSimTryonMaskId // 取上下装分割结果
    const getSemanticSimTryonMaskIdClothTypeAll = UtilsAlgo.getSemanticSimTryonMaskIdClothTypeAll // 取全label分割结果
    const getModelMaskId = UtilsAlgo.getModelMaskId
    const getGoodsMaskId = UtilsAlgo.getGoodsMaskId
    const getSemanticClothMaskId = UtilsAlgo.getSemanticClothMaskId
    const getInteractiveNpyId = UtilsAlgo.getInteractiveNpyId
    const getClothMaskOutput = id => UtilsAlgo.getClothMaskOutput(id, () => !isMounted.current)
    const getModelColorMaskId = UtilsAlgo.getModelColorMaskId
    const getColorMaskOutput = id => UtilsAlgo.getColorMaskOutput(id, () => !isMounted.current)
    const getModelRecommendFilter = (...args) => UtilsAlgo.getModelRecommendFilter(...args, () => !isMounted.current)
    const getCommodityRecommendFilter = UtilsAlgo.getCommodityRecommendFilter
    const getAiRemove = (...args) => UtilsAlgo.getAiRemove(...args, () => !isMounted.current)

    return (
        <GenerateContext.Provider value={{
            inputImageLoading, setInputImageLoading,
            topInputImageLoading, setTopInputImageLoading,
            bottomInputImageLoading, setBottomInputImageLoading,
            no1MultiAngleImageLoading, setNo1MultiAngleImageLoading,
            no2MultiAngleImageLoading, setNo2MultiAngleImageLoading,

            imageType,
            // 项目id
            projectId, setProjectId,

            // 输入图/单件服装
            inputImage, setInputImage,
            // 输入图宽度
            inputImageWidth, setInputImageWidth,
            // 输入图高度
            inputImageHeight, setInputImageHeight,
            // 输入图原始mask
            inputImageOriginalMask, setInputImageOriginalMask,
            // 输入图编辑后的mask
            inputImageEditedMask, setInputImageEditedMask,
            // 输入图分割id
            inputImageMaskId, setInputImageMaskId,
            // 多语义分割id
            inputImageMultiSemanticId, setInputImageMultiSemanticId,
            // 输入图npy算法id
            inputImageNpyId, setInputImageNpyId,

            // 仅AI模特
            inputImageColorMaskId, setInputImageColorMaskId,

            // 仅AI试衣
            inputImageClothType, setInputImageClothType,
            // 上装输入图
            topInputImage, setTopInputImage,
            // 顶部输入图宽度
            topInputImageWidth, setTopInputImageWidth,
            // 顶部输入图高度
            topInputImageHeight, setTopInputImageHeight,
            // 顶部输入图原始mask
            topInputImageOriginalMask, setTopInputImageOriginalMask,
            // 顶部输入图编辑后的mask
            topInputImageEditedMask, setTopInputImageEditedMask,
            // 顶部输入图分割id
            topInputImageMaskId, setTopInputImageMaskId,
            // 顶部输入图npy算法id
            topInputImageNpyId, setTopInputImageNpyId,
            // 下装输入图
            bottomInputImage, setBottomInputImage,
            // 底部输入图宽度
            bottomInputImageWidth, setBottomInputImageWidth,
            // 底部输入图高度
            bottomInputImageHeight, setBottomInputImageHeight,
            // 底部输入图原始mask
            bottomInputImageOriginalMask, setBottomInputImageOriginalMask,
            // 底部输入图编辑后的mask
            bottomInputImageEditedMask, setBottomInputImageEditedMask,
            // 底部输入图分割id
            bottomInputImageMaskId, setBottomInputImageMaskId,
            // 底部输入图npy算法id
            bottomInputImageNpyId, setBottomInputImageNpyId,

            // 仅鞋子上脚
            // 多视角图
            no1MultiAngleImage, setNo1MultiAngleImage,
            // 多视角图宽度
            no1MultiAngleImageWidth, setNo1MultiAngleImageWidth,
            // 多视角图高度
            no1MultiAngleImageHeight, setNo1MultiAngleImageHeight,
            // 多视角图分割id
            no1MultiAngleImageMaskId, setNo1MultiAngleImageMaskId,
            // 多视角图原始mask
            no1MultiAngleImageOriginalMask, setNo1MultiAngleImageOriginalMask,
            // 多视角图编辑后的mask
            no1MultiAngleImageEditedMask, setNo1MultiAngleImageEditedMask,
            // 多视角图npy算法id
            no1MultiAngleImageNpyId, setNo1MultiAngleImageNpyId,
            // 多视角图
            no2MultiAngleImage, setNo2MultiAngleImage,
            // 多视角图宽度
            no2MultiAngleImageWidth, setNo2MultiAngleImageWidth,
            // 多视角图高度
            no2MultiAngleImageHeight, setNo2MultiAngleImageHeight,
            // 多视角图分割id
            no2MultiAngleImageMaskId, setNo2MultiAngleImageMaskId,
            // 多视角图原始mask
            no2MultiAngleImageOriginalMask, setNo2MultiAngleImageOriginalMask,
            // 多视角图编辑后的mask
            no2MultiAngleImageEditedMask, setNo2MultiAngleImageEditedMask,
            // 多视角图npy算法id
            no2MultiAngleImageNpyId, setNo2MultiAngleImageNpyId,

            // 仅商品
            // 商品自定义场景配置
            refImgConfig, setRefImgConfig,
            // 商品自定义场景强度
            refImgStrength, setRefImgStrength,
            // 商品图输出比例
            outputRatio, setOutputRatio,
            // 商品图输出宽度
            outputWidth, setOutputWidth,
            // 商品图输出高度
            outputHeight, setOutputHeight,
            // 输入图的位置、缩放、尺寸、旋转等信息 (原dragScaleRef.current)
            inputImageTransform, setInputImageTransform,

            // 试衣模特选择
            tryonModelKeyList, setTryonModelKeyList,
            // 姿势裂变参考图选择
            poseTryonKeyList, setPoseTryonKeyList,
            // 眼镜试戴参考图选择
            glassesTryonKeyList, setGlassesTryonKeyList,
            // 相似度试戴参考图选择
            simTryonKeyList, setSimTryonKeyList,
            // 模特选择
            modelKeyList, setModelKeyList,
            // 场景选择
            sceneKeyList, setSceneKeyList,
            // 鞋子选择
            shoesKeyList, setShoesKeyList,
            // 视频选择
            videoKeyList, setVideoKeyList,
            // 商品颜色选择
            colorKeyList, setColorKeyList,

            // 生成数量
            generateNum, setGenerateNum,
            // 生成模式
            generateMode, setGenerateMode,
            // 人像皮肤优化
            skinRefine, setSkinRefine,
            // 人像光影融合
            relight, setRelight,
            // 自定义背景模式 =free 更加自由 =sim 非常相似
            customBkgMode, setCustomBkgMode,
            // 模特换背是否选择输出参考图分辨率 input or bkg
            resolutionAlign, setResolutionAlign,
            // 输入图类型：单件服装/上下搭配 | 单视角图/多视角图
            currentInputType, setCurrentInputType,
            // 资源筛选
            resourceFilter, setResourceFilter,

            generateDisabled,
            getMultiSemanticId,
            getClothMaskId,
            getShoesMaskId,
            getGlassesMaskId,
            getSimMaskId,
            // 同版型试衣素材多余义分割ID
            getSemanticSimTryonMaskId,
            getSemanticSimTryonMaskIdClothTypeAll,
            getModelMaskId,
            getGoodsMaskId,
            getSemanticClothMaskId,
            getInteractiveNpyId,
            getClothMaskOutput,
            getMultiSemanticOutput,
            getModelColorMaskId,
            getColorMaskOutput,
            getModelRecommendFilter,
            getCommodityRecommendFilter,
            getAiRemove,
        }}>
            {props.children}
        </GenerateContext.Provider>
    );
}
